import { fromJS } from 'immutable'
import moment from '../../../lib/moment'

import { GET_REPORT, DATE, FILTER, SORT, MODULE, GET_EXPORT } from './constants'
import { toProjects } from './model'

/**
 * @typedef {import('./model').BillingPlanReport} BillingPlanReport
 */

/** @type {import('immutable').Map} */
const initialState = fromJS({
  fetching: false,
  redirect: false,
  display_actual: false,
  date: {
    from: moment().subtract(1, 'months'),
    to: moment(),
  },
  filter: {
    lob: '',
    other: '',
  },
  sort: { field: 'code', order: 'asc' },
  projects: /** @type {BillingPlanReport[]} */ ([]),
})

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_REPORT.REQUEST:
      return state.set('fetching', true)
    case GET_REPORT.SUCCESS:
      return state
        .set('fetching', false)
        .set('projects', fromJS(toProjects(action.payload)))
        .set('display_actual', Boolean(action.payload.can_display_actual_cost))
    case GET_REPORT.FAILURE:
      return state
    case GET_EXPORT.REQUEST:
      return state.set('fetching', true)
    case GET_EXPORT.SUCCESS:
      return state
        .set('fetching', false)
        .set('url', fromJS(action.payload.url))
    case GET_EXPORT.FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('fetching', false)
    case GET_EXPORT.RESET:
      return state
        .delete('url')
        .set('fetching', false)
    case DATE.SET_FIELD:
      return state.setIn(['date', action.payload[0]], action.payload[1])
    case FILTER.SET_FIELD:
      return state.setIn(['filter', action.payload[0]], action.payload[1])
    case SORT.SET_FIELD:
      return state.setIn(['sort', action.payload[0]], action.payload[1])
    case MODULE.RESET:
      return initialState
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/pages/report/billing-plan/reducer.js